import React, { useState, useEffect } from "react";
import { Container, Grid, Typography, Box, Fade } from "@mui/material";

import aboutUsImage from "../assets/img/aboutus.JPEG.webp";
import foundersImage from "../assets/img/founders_image.JPG.webp";

const founderPedigree = [
  "Founded by two architects and interior designers, our practice is rooted in a shared journey that began long before design became our profession. Alumni of Rachana Sansad Academy of Architecture, we graduated in 2019 and spent our early years working across diverse studios—learning, observing, and refining our approach—before confidently starting our own practice in 2020.",
  "What began as two founders working hands-on with projects has organically grown into a studio with its own space and a team of six and growing. This growth has been steady, intentional, and deeply humbling, and we remain immensely grateful for the trust our clients place in us.",
  "Our design philosophy is simple: functionality and design should coexist seamlessly. We believe every home is as unique as its owner—much like a fingerprint. Each project begins not with drawings, but with conversations. We immerse ourselves in our clients’ stories, routines, and lifestyles, allowing these narratives to shape spaces that feel intuitive, personal, and timeless.",
  "Beyond our professional partnership lies a friendship that dates back to our school years. Over time, that friendship has evolved into a creative collaboration built on trust, shared values, and mutual respect—forming the foundation of everything we design today.",
];

const AboutUs = () => {
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    setFadeIn(true);
  }, []);

  return (
    <Container maxWidth={false} sx={{ maxWidth: "1000px", mt: 3, mb: 8, px: { xs: "1rem", sm: "1rem", md: "0rem" } }}>
      {/* First Two-Column Section */}
      <Fade in={fadeIn} timeout={1000}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="h3" component="h1" gutterBottom fontFamily={"Audrey"}>
              ABOUT
            </Typography>
            <Typography variant="body1" color="text.secondary" fontFamily={"Avenir"}>
              Alchemy Collective is a creative studio for curious minds, makers, and dreamers. We believe in the power of collaboration and experimentation. Our mission is to nurture creativity, foster community, and help ideas come to life through workshops, events, and shared resources.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src={aboutUsImage}
              alt="About Alchemy Collective"
              sx={{
                width: "100%",
                // borderRadius: 2,
                // boxShadow: 3,
                objectFit: "cover",
                minHeight: 250,
              }}
              loading="lazy"
            />
          </Grid>
        </Grid>
      </Fade>

      {/* Second Two-Column Section */}
      <Fade in={fadeIn} timeout={2000}>
        <Grid container spacing={4} alignItems="center" sx={{ mt: 4 }}>
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src={foundersImage}
              alt="Founders"
              sx={{
                width: "100%",
                // borderRadius: 2,
                // boxShadow: 3,
                objectFit: "cover",
                minHeight: 250,
              }}
              loading="lazy"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="h4" component="h3" gutterBottom fontFamily={"Audrey"}>
              FOUNDERS
            </Typography>
            {founderPedigree.map((text, index) => (
              <Typography
                key={index}
                variant="body1"
                color="text.secondary"
                fontFamily={"Avenir"}
                paragraph
              >
                {text}
              </Typography>
            ))}
          </Grid>
        </Grid>
      </Fade>
    </Container>
  );
};

export default AboutUs;
